import { render } from "./CircularProgressBar.vue?vue&type=template&id=075d2a96"
import script from "./CircularProgressBar.vue?vue&type=script&lang=js"
export * from "./CircularProgressBar.vue?vue&type=script&lang=js"
script.render = render

export default script